export default __webpack_public_path__ + "static/media/Logo.867692fe.png";